import React from "react";
import classNames from "classnames";
import TopBanner from "./TopBanner";
import { FooterParkWeb } from "./FooterParkWeb";
import { AdContent } from "../AdContent";
import ParkwebGetDomain from "./ParkwebGetDomain";
import { useAuctionArmEffects } from "../../experimentation/useAuctionArmEffects";
import classes from "./ParkWebLayout.module.scss";

export default function ParkWebLayout() {
  // PARKING-5212: on-lander auction arms (control + treatment_b CTA repoint + exposure).
  useAuctionArmEffects();
  return (
    <div className={ classes.parkWebLander }>
      <TopBanner flexColumnOnMobile={ true } />
      <div className={ classes.getDomainSection }>
        <ParkwebGetDomain />
      </div>
      <div className={ classNames(classes.adContent) }>
        <AdContent />
      </div>
      <FooterParkWeb
        copyrightTextId="parkwebcopyrightText"
        parkwebDisclaimerText="parkwebDisclaimerText"
      />
    </div>
  );
}
